/*
 * Copyright (c) Nexign, JSC, 2021.
 */
/**
 * Async state management reducers
 *
 * @author Yakov Gushchin
 * @version 1.11.0
 * @since 1.11.0
 */

import produce from 'immer';
import { Reducer } from 'redux';
import { Task } from 'redux-saga';

import {
    ASYNC_STATE_MANAGEMENT_INIT,
    ASYNC_STATE_MANAGEMENT_INIT_SUCCESS,
    ASYNC_STATE_MANAGEMENT_SAVE,
    ASYNC_STATE_MANAGEMENT_UNMOUNT_SUCCESS,
} from './asyncStateManagementConstants';
import { TAsyncStateManagementActions } from './asyncStateManagementTypes';


export interface IAsyncStateManagementReducer {
    activeSagasTask: { [id: string]: Task };
    isLoaded: { [id: string]: boolean };
}

export const initialAsyncStateManagerState: IAsyncStateManagementReducer = {
    activeSagasTask: {},
    isLoaded: {},
};

export const asyncStateManagementReducer: Reducer<IAsyncStateManagementReducer, TAsyncStateManagementActions> =
    (state = initialAsyncStateManagerState, action: TAsyncStateManagementActions) =>
        produce(state, draft => {
            switch (action.type) {
                case ASYNC_STATE_MANAGEMENT_INIT:
                    draft.isLoaded[action.payload.id] = false;
                    break;
                case ASYNC_STATE_MANAGEMENT_INIT_SUCCESS:
                    draft.isLoaded[action.payload.id] = true;
                    break;
                case ASYNC_STATE_MANAGEMENT_UNMOUNT_SUCCESS:
                    delete draft.activeSagasTask[action.payload];
                    delete draft.isLoaded[action.payload];
                    break;

                case ASYNC_STATE_MANAGEMENT_SAVE:
                    draft.activeSagasTask[action.payload.id] = action.payload.task;
                    break;
            }
        });
